import AdminList from '@/pages/admin/admin/routes'
import AdminRole from '@/pages/admin/role/routes'

export default {
  path: 'admin',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [...AdminList, ...AdminRole]
}
